import { render } from "./ExampleCard.vue?vue&type=template&id=19b7fa88"
import script from "./ExampleCard.vue?vue&type=script&lang=js"
export * from "./ExampleCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Demo/ExampleCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19b7fa88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19b7fa88', __exports__)) {
    api.reload('19b7fa88', __exports__)
  }
  
  module.hot.accept("./ExampleCard.vue?vue&type=template&id=19b7fa88", () => {
    api.rerender('19b7fa88', render)
  })

}


export default __exports__